export interface HeaderInfo {
  title?: string;
  name?: string;
  statusCode?: string | any;
  data?: any;
}

export class HeaderInfo {
}
